import styled from "styled-components";

import {
  Form as FormAnt,
  Input as InputAnt,
  Button as ButtonAnt,
  Select as SelectAnt,
  DatePicker as DatePickerAnt,
  Col as ColAnt,
  Row as RowAnt,
  Alert as AlertAnt,
} from "antd";

import { LogOut } from "../../styles/Icons";
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
  padding: 1rem;
  overflow-y: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 56rem;
  height: 50rem;
  max-width: 90%;
  padding: 1rem;
  border-radius: 8px;
  background: var(--white);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 1.5rem;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    max-width: 100%;
  }
`;

export const Form = styled(FormAnt)`
  width: 100%;
  max-width: 800px;

  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::after {
    display: inline-block;
    color: var(--orange-150);
    content: "*";
  }

  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    content: "";
  }

  @media (max-width: 480px) {
    .ant-form-item {
      margin-bottom: 12px;
    }
  }
`;

export const FormItem = styled(FormAnt.Item)`
  margin-bottom: 1rem;

  @media (max-width: 480px) {
    margin-bottom: 0.75rem;
  }
`;

export const Input = styled(InputAnt)`
  border: 1px solid var(--gray-100) !important;
  border-radius: 0.3rem !important;
  height: 2.7rem !important;
`;

export const Select = styled(SelectAnt)`
  height: 2.7rem !important;
  border: 1px solid var(--gray-100) !important;
  border-radius: 0.3rem !important;
  padding: 4px 11px !important;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DatePicker = styled(DatePickerAnt)`
  width: 100%;
  height: 2.7rem !important;
  border: 1px solid var(--gray-100) !important;
  border-radius: 0.3rem !important;

  input {
    height: 42px;
  }
`;

export const Button = styled(ButtonAnt)`
  width: 100%;
  height: 2.6rem;
  border-radius: 6px;
  font-weight: 500;
  background-color: var(--orange-100);
  border: none;
  color: var(--white);

  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    background-color: var(--orange-150);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h1 {
    font-size: 2rem;
    color: var(--black-opaco);
    font-weight: 600;
    margin-bottom: 0.5rem;

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }

    @media (max-width: 480px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--gray-500);
    font-size: 1rem;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }
`;

export const Logo = styled.img`
  height: 70px;

  @media (max-width: 480px) {
    height: 50px;
    margin-bottom: 0.75rem;
  }
`;

export const Row = styled(RowAnt)`
  width: 100%;
`;

export const Col = styled(ColAnt)``;

export const ProfileImageContainer = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 1.5rem;
  border: 2px solid var(--gray-20);

  @media (max-width: 480px) {
    width: 80px;
    height: 80px;
    margin: 0 auto 1rem;
  }
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileImageUploadOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;

  ${ProfileImageContainer}:hover & {
    opacity: 1;
  }

  @media (max-width: 768px) {
    opacity: 0.8;
    height: 25px;
  }

  .dropzone {
    border: none;
    height: 100%;
    color: white;
  }

  p {
    color: white !important;
    font-size: 12px;
    margin: 0;

    @media (max-width: 480px) {
      font-size: 10px;
    }
  }
`;

export const Alert = styled(AlertAnt)`
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
`;

export const ButtonLogout = styled(ButtonAnt)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--orange-100);
  width: 5rem;
  border-radius: 0.3rem;
  color: var(--white);

  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    background-color: var(--orange-150);
    color: var(--white);
  }
`;

export const LogOutIcon = styled(LogOut)`
  margin-right: 0.4rem;
  width: 1.5rem;
  height: 1.5rem;
`;
